import { useState } from 'react';
import WizardCard from './WizardCard.jsx';

// Prompt-only step (no DB persistence in v1). Asks per-MIT whether it should
// be a calendar block, and if so what time. Surfaces those answers in the
// confirmation step but does not create calendar events.
export default function StepCalendarBlocks({
  briefing,
  onBlocksChange,
  onBack,
  onNext,
}) {
  const mits = [1, 2, 3].map((i) => briefing?.[`mit_${i}_text`] ?? '');

  // Each entry: { asBlock: boolean | null, time: 'HH:MM' | '' }
  const [decisions, setDecisions] = useState(() =>
    mits.map(() => ({ asBlock: null, time: '' }))
  );

  function update(idx, patch) {
    setDecisions((prev) => {
      const next = [...prev];
      next[idx] = { ...next[idx], ...patch };
      return next;
    });
  }

  function handleNext() {
    onBlocksChange(
      decisions.map((d, i) => ({
        text: mits[i],
        asBlock: !!d.asBlock,
        time: d.time,
      }))
    );
    onNext();
  }

  return (
    <WizardCard
      step={6}
      title="Should any of these be calendar blocks?"
      subtitle="Just a prompt — no auto-create yet."
      onBack={onBack}
      onNext={handleNext}
    >
      <div className="space-y-4">
        {mits.map((text, idx) => (
          <div key={idx} className="border border-border-base rounded p-3">
            <div className="text-sm text-text-primary mb-2">
              <span className="text-text-muted mr-1">{idx + 1}.</span> {text}
            </div>
            <div className="flex gap-2 mb-2">
              <YesNoMini
                label="Yes"
                active={decisions[idx].asBlock === true}
                onClick={() => update(idx, { asBlock: true })}
              />
              <YesNoMini
                label="No"
                active={decisions[idx].asBlock === false}
                onClick={() => update(idx, { asBlock: false, time: '' })}
              />
            </div>
            {decisions[idx].asBlock && (
              <input
                type="time"
                value={decisions[idx].time}
                onChange={(e) => update(idx, { time: e.target.value })}
                className="w-full px-3 py-2 bg-bg-input border border-border-base rounded text-sm text-text-primary focus:outline-none focus:border-accent-blue"
              />
            )}
          </div>
        ))}
      </div>
    </WizardCard>
  );
}

function YesNoMini({ label, active, onClick }) {
  return (
    <button
      onClick={onClick}
      className={`flex-1 py-1.5 text-sm font-medium rounded border transition ${
        active
          ? 'bg-accent-blue text-white border-accent-blue'
          : 'bg-bg-input text-text-primary border-border-base hover:border-accent-blue/40'
      }`}
    >
      {label}
    </button>
  );
}
